export enum TooltipPlacement {
  Left = 'left',
  BottomLeft = 'bottomLeft',
  Bottom = 'bottom',
}

export enum TooltipTrigger {
  Click = 'click',
}
